import { IconProps } from "./";
import Icon from "./assets/suit_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Suit(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
